import React from "react";

const BulbIcon = ({ width = 24, height = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <rect
        width="24"
        height="24"
        rx="6"
        fill="url(#paint0_linear_31942_113919)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.31614 9.71436C8.0696 7.74207 9.60747 6 11.5951 6H12.5919C14.5817 6 16.1212 7.74391 15.8744 9.71829L15.8366 10.0209C15.7634 10.6063 15.9762 11.1912 16.4085 11.5927L16.4342 11.6166C17.3786 12.4936 17.5619 13.9199 16.8699 15.0072C16.4176 15.7178 15.6594 16.1698 14.8278 16.2356L14.7158 16.4275C14.123 17.4438 13.1993 18 12.2293 18C11.2593 18 10.3356 17.4438 9.74277 16.4275L9.63256 16.2386C8.64252 16.1769 7.75566 15.5873 7.31889 14.6868L7.25839 14.5621C6.76279 13.5404 6.99465 12.3147 7.8292 11.5446C8.23193 11.1729 8.43056 10.6298 8.36259 10.086L8.31614 9.71436ZM10.6703 16.2439C11.1148 16.8513 11.6901 17.122 12.2293 17.122C12.7685 17.122 13.3438 16.8513 13.7883 16.2439H10.6703Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_31942_113919"
          x1="12"
          y1="0"
          x2="12"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF9728" />
          <stop offset="1" stopColor="#DC7609" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BulbIcon;
